import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 8h-5.2l-1.22-2a2 2 0 0 0-1.71-1h-7.74a2 2 0 0 0-1.71 1L9.2 8H7a1 1 0 0 0-2 0H4a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2M16 24a7 7 0 1 1 7-7 7 7 0 0 1-7 7m10-10a2 2 0 1 1 2-2 2 2 0 0 1-2 2" />
    <path d="M16 12a5 5 0 1 0 0 10 5 5 0 1 0 0-10" />
  </svg>
);
const ForwardRef = forwardRef(IconCameraFilledSVG);
ForwardRef.displayName = "IconCameraFilled";
export { ForwardRef as IconCameraFilled };
